const init = () => {
  const movieElm = document.querySelector('.js-movie');
  const movieStopButton = document.querySelector('.js-movieStop');
  const hasMovieStartButtonWrap = document.querySelector('.js-modal:has(.js-movieMain)');
  const movieStartButton = hasMovieStartButtonWrap.querySelector('.js-modalClose');

  movieStopButton.addEventListener('click', () => {
    // youtube iframe apiを使って一時停止
    const iframeWindow = movieElm.contentWindow;
    iframeWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
  });

  movieStartButton.addEventListener('click', () => {
    // youtube iframe apiを使って再生
    const iframeWindow = movieElm.contentWindow;
    iframeWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
  });
};

export {
    init,
};
